export const monthsOfYearModel = [
	{ label: "Janeiro", 	id: "jan" },
	{ label: "Fevereiro", id: "feb" },
	{ label: "Março", 		id: "mar" },
	{ label: "Abril", 		id: "apr" },
	{ label: "Maio", 			id: "may" },
	{ label: "Junho", 		id: "jun" },
	{ label: "Julho", 		id: "jul" },
	{ label: "Agosto", 		id: "aug" },
	{ label: "Setembro", 	id: "sep" },
	{ label: "Outubro", 	id: "oct" },
	{ label: "Novembro", 	id: "nov" },
	{ label: "Dezembro", 	id: "dec" }
];
















// WEBPACK FOOTER //
// src/models/lib/monthsOfYearModel.js